import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import '../assets/css/HomePage.css';
import { b1, b6 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ---------------- SEO helpers ---------------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// href перед hreflang — как ты просил
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Bet = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

useEffect(() => {
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // Альтернативные URL
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // ===== Тексты (EN → BN перевод) =====
  const pageTitleEN = "HHBD Bet — Cricket, Football & Kabaddi Bets BD";
  const pageDescEN =
    "Bet live on cricket, football & kabaddi with HHBD! Enjoy real-time odds, secure BDT betting, and instant cashouts through bKash or Nagad. Trusted by Bangladeshi players for safe and exciting sports action.";

  const pageTitleBN = "HHBD বেট — ক্রিকেট, ফুটবল এবং কাবাডি বেটস বিডি";
  const pageDescBN =
    "HHBD-এর মাধ্যমে ক্রিকেট, ফুটবল এবং কাবাডিতে সরাসরি বাজি ধরুন! বিকাশ বা নগদের মাধ্যমে রিয়েল-টাইম অডস, নিরাপদ বাংলাদেশি টাকা বাজি এবং তাৎক্ষণিক ক্যাশআউট উপভোগ করুন। নিরাপদ এবং উত্তেজনাপূর্ণ ক্রীড়া ক্রিয়াকলাপের জন্য বাংলাদেশি খেলোয়াড়দের দ্বারা বিশ্বস্ত।";

  const pageKeywordsEN =
    "HHBD Bet, sports betting BD, cricket betting Bangladesh, football odds BD, kabaddi betting BD, live betting Bangladesh";
  const pageKeywordsBN =
    "HHBD স্পোর্টস, ক্রিকেট বেট, ফুটবল বেটিং, কাবাডি বেট, অনলাইন বেট বাংলাদেশ, লাইভ বেটিং";

  const isBN = lang === "bn";

  // ===== Требования: все тайтлы (обычные) и микроразметка — UPPERCASE =====
  const pageTitle = (isBN ? pageTitleBN : pageTitleEN).toUpperCase(); // тайтл сразу в верхнем регистре
  const pageDesc = isBN ? pageDescBN : pageDescEN;                    // description (обычный регистр)
  const pageKeywords = isBN ? pageKeywordsBN : pageKeywordsEN;        // keywords (обычный регистр)

  // ---------- Open Graph / Twitter изображения ----------
  const ogImage = toAbsoluteUrl(b1);
  const twitterSite = "@HHBD_official";    // замените на реальный @
  const twitterCreator = "@HHBD_official"; // замените при необходимости
  const twitterImageAlt = isBN
    ? "HHBD-এর মাধ্যমে ক্রিকেট এবং ফুটবলে বাজি ধরুন - বাংলাদেশের বিশ্বস্ত স্পোর্টসবুক যেখানে লাইভ অডস এবং দ্রুত উত্তোলনের সুবিধা রয়েছে।"
    : "Bet on cricket and football with HHBD – Bangladesh’s trusted sportsbook featuring live odds and fast withdrawals.";

  // ---------- Заголовок/description/keywords ----------
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaName("description", pageDesc);       // обычный регистр
  setMetaName("keywords", pageKeywords);      // обычный регистр

  // Canonical + hreflang (+ x-default на en)
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // ---------- Open Graph (тайтл в UPPERCASE) ----------
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);          // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc);     // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? pageTitleBN : pageTitleEN); // alt — читаемый
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // ---------- Twitter (тайтл в UPPERCASE + twitter:url) ----------
  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);         // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);    // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);       // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);

  // label/data пары (до 2)
  setMetaName("twitter:label1", isBN ? "স্পোর্টস" : "Sports");
  setMetaName("twitter:data1", isBN ? "ক্রিকেট, ফুটবল, কাবাডি" : "Cricket, Football, Kabaddi");
  setMetaName("twitter:label2", isBN ? "প্ল্যাটফর্ম" : "Platform");
  setMetaName("twitter:data2", "Android");

  
}, [lang, pathname]);



  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/bet";

      // Copy synced with your visible page text
      const titleEN = "HHBD Bet — Cricket, Football & Kabaddi Bets BD";
      const descEN =
        "Bet live on cricket, football & kabaddi with HHBD! Enjoy real-time odds, secure BDT betting, and instant cashouts through bKash or Nagad. Trusted by Bangladeshi players for safe and exciting sports action.";

      const titleBN = "HHBD বেট — ক্রিকেট, ফুটবল এবং কাবাডি বেটস বিডি";
      const descBN =
        "HHBD-এর মাধ্যমে ক্রিকেট, ফুটবল এবং কাবাডিতে সরাসরি বাজি ধরুন! বিকাশ বা নগদের মাধ্যমে রিয়েল-টাইম অডস, নিরাপদ বাংলাদেশি টাকা বাজি এবং তাৎক্ষণিক ক্যাশআউট উপভোগ করুন। নিরাপদ এবং উত্তেজনাপূর্ণ ক্রীড়া ক্রিয়াকলাপের জন্য বাংলাদেশি খেলোয়াড়দের দ্বারা বিশ্বস্ত।";

      // Uppercase for microdata titles/descriptions
      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps = (isBN ? descBN : descEN);
      const inLang = isBN ? "bn" : "en";

      // Organization description

      // Use hero as primary image
      const ogImage =
        typeof b1 === "string"
          ? (/^https?:\/\//i.test(b1) ? b1 : `${origin}${b1.startsWith("/") ? "" : "/"}${b1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage (Bet / Sportsbook)
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization (with description)
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {b1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (no downloadUrl per request)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
<>
    <section className="zHHBD-bet-hero">
      <div className="zHHBD-bet-hero__bg">
        <div className="zHHBD-bet-hero__overlay"></div>
        <div className="zHHBD-bet-hero__flare zHHBD-bet-hero__flare--left"></div>
        <div className="zHHBD-bet-hero__flare zHHBD-bet-hero__flare--right"></div>
      </div>

      <div className="zHHBD-bet-hero__container">
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Bet — Ultra-fast sports wagering with sharp prices for Bangladesh"
        >
          <img
            src={b1}
            alt="Focused bettor placing live sports wagers from home on the HHBD platform via laptop."
            title="HHBD Bet — Ultra-fast sports wagering with sharp prices for Bangladesh"
          />
        </a>

        <div className="zHHBD-bet-hero__content">
          <header className="zHHBD-bet-hero__header">
            <h1 className="zHHBD-bet-hero__title">
              HHBD Bet – Live Sports Betting for Bangladesh Players
            </h1>
            <p className="zHHBD-bet-hero__desc">
              Enter HHBD Bets — the definitive destination for online sports {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} fans across the country. Transform your analysis into real results by {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} on favourite clubs, elite athletes, and marquee competitions. Explore deep markets, value-first pricing, and powerful {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link> utilities built for momentum. At HHBD, passion aligns with opportunity — dive in now!
            </p>
          </header>

          <div className="zHHBD-bet-hero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bet-hero__btn zHHBD-bet-hero__btn--main"
              title="Create your HHBD Sportsbook account and start wagering right away"
            >
              Join HHBD Today
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bet-hero__btn zHHBD-bet-hero__btn--ghost"
              title="Download the official HHBD Android sportsbook app"
              download
            >
              Download APK
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-sportsbet">
      <div className="zHHBD-sportsbet__bg">
        <div className="zHHBD-sportsbet__flare zHHBD-sportsbet__flare--left"></div>
        <div className="zHHBD-sportsbet__flare zHHBD-sportsbet__flare--right"></div>
      </div>

      <div className="container hr-cont">
        <header className="zHHBD-sportsbet__header">
          <h2 className="zHHBD-sportsbet__title">
            Experience the HHBD Sportsbook Up Close
          </h2>
        </header>
        <p className="zHHBD-sportsbet__desc">
          HHBD places you at the centre of every moment with a full-scale, fluid {" "}
          <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} ecosystem. Our mission is a silky, captivating {" "}
          <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} journey crafted for Bangladesh’s sports community. From seasoned veterans to first-timers, you’ll find precisely the tools and markets you need.
        </p>
        <p className="zHHBD-sportsbet__desc">
          We showcase a vast catalogue of fixtures worldwide, with special focus on the contests local fans care about most. From the pulse of the Bangladesh Premier League to the drama of the FIFA World Cup, you can {" "}
          <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bet</Link>{" "} on every defining narrative. Your gateway to both regional and global events begins here.
        </p>
        <p className="zHHBD-sportsbet__desc">
          Placing a {" "}
          <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bet</Link>{" "} on HHBD is fast and intuitive. Find your match, evaluate live lines, and confirm your stake in seconds. With streamlined navigation, you’re free to back favourites or hunt value the instant it appears.
        </p>
        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-sportsbet__btn"
          title="Browse all sports and live markets available on HHBD"
        >
          Join HHBD Now
        </a>
      </div>
    </section>

    <section className="zHHBD-sports-cards">
      <div className="zHHBD-sports-cards__bg">
        <div className="zHHBD-sports-cards__burst zHHBD-sports-cards__burst--1"></div>
        <div className="zHHBD-sports-cards__burst zHHBD-sports-cards__burst--2"></div>
      </div>

      <div className="zHHBD-sports-cards__container">
        <header className="zHHBD-sports-cards__header">
          <h2 className="zHHBD-sports-cards__title">Why Make HHBD Your Sportsbook?</h2>
          <div className="zHHBD-sports-cards__desc">
            <p></p>
          </div>
        </header>

        <div className="zHHBD-sports-cards__grid">
          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">Choosing the right home for your stakes defines your whole journey.</div>
              <div className="zHHBD-sports-cards__card-text">
                HHBD provides a resilient, credible environment that heightens excitement while safeguarding every session. We’re dedicated to a rewarding, transparent, and value-driven platform for bettors across Bangladesh.
              </div>
            </div>
          </div>

          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">Our lines stand out with razor-sharp, consistently competitive odds.</div>
              <div className="zHHBD-sports-cards__card-text">
                We constantly tune our books to deliver stronger expected returns for your {" "}
                <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bets</Link>{" "} on HHBD. Sharper pricing means bigger potential paydays, giving you more upside when you back teams or standout performers.
              </div>
            </div>
          </div>

          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">Enjoy massive market depth on every matchup in the schedule.</div>
              <div className="zHHBD-sports-cards__card-text">
                It’s far more than picking a winner. You can {" "}
                <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bet</Link>{" "} on totals, player milestones, handicaps, and a rich array of in-play outcomes as momentum shifts and the action evolves in real time.
              </div>
            </div>
          </div>

          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">A truly wide-reaching book that spans virtually every sport.</div>
              <div className="zHHBD-sports-cards__card-text">
                From world-stage spectacles to local Bangladeshi showdowns, our coverage runs deep. Whatever you follow, you’ll uncover exciting {" "}
                <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} angles and markets ready for your approach.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-livebet">
      <div className="zHHBD-livebet__bg">
        <div className="zHHBD-livebet__flare zHHBD-livebet__flare--1"></div>
        <div className="zHHBD-livebet__flare zHHBD-livebet__flare--2"></div>
      </div>

      <div className="zHHBD-livebet__container">
        <div className="zHHBD-livebet__content">
          <header className="zHHBD-livebet__header">
            <h2 className="zHHBD-livebet__title">
              Feel the Adrenaline of Live, In-Play Wagers
            </h2>
          </header>

          <div className="zHHBD-livebet__descbox">
            <p className="zHHBD-livebet__desc">
              Supercharge matchday with HHBD’s real-time, in-play {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>. Stake as the contest unfolds and pounce on shifting edges the moment they surface. With live, constantly updating prices, you can find value at the precise time to place your {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bets</Link>.
            </p>
            <p className="zHHBD-livebet__desc">
              Live {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} is perfect for fans tracking every delivery and pass. React to goals, boundaries, wickets, cards, and crucial moments — then fire a targeted {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bet</Link>{" "} on what’s likely next. It adds timing, strategy, and extra theatre to your HHBD {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">betting</Link>{" "} experience.
            </p>
            <p className="zHHBD-livebet__desc">
              To sharpen your reads and improve your live {" "}
              <Link className="zHHBD-gameshero__link" to="/bet" data-discover="true">bets</Link>, tap into real-time stats and visual match trackers. These details reveal tempo and turning points, helping you anticipate decisive swings. With HHBD, smarter in-play wagering is always a tap away.
            </p>
          </div>

          <div className="zHHBD-livebet__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-livebet__btn"
              title="See every live and upcoming market waiting for you on HHBD"
            >
              Place Bet on HHBD
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Bet — Real-time wagering and big wins across Bangladesh"
        >
          <img
            src={b6}
            alt="Overjoyed Bangladeshi supporter celebrating a winning cricket wager on HHBD while checking the score on his phone."
            title="HHBD Bet — Real-time wagering and big wins across Bangladesh"
          />
        </a>
      </div>
    </section>
  </>






      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
 <>
    <section className="zHHBD-bet-hero">
      <div className="zHHBD-bet-hero__bg">
        <div className="zHHBD-bet-hero__overlay"></div>
        <div className="zHHBD-bet-hero__flare zHHBD-bet-hero__flare--left"></div>
        <div className="zHHBD-bet-hero__flare zHHBD-bet-hero__flare--right"></div>
      </div>

      <div className="zHHBD-bet-hero__container">
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Bet — বাংলাদেশে বজ্রগতির স্পোর্টস ওয়েজারিং ও ধারালো অডস"
        >
          <img
            src={b1}
            alt="ঘরে বসে ল্যাপটপে HHBD প্ল্যাটফর্মে লাইভ স্পোর্টস বেট করছেন এক মনোযোগী বেটর।"
            title="HHBD Bet — বাংলাদেশে বজ্রগতির স্পোর্টস ওয়েজারিং ও ধারালো অডস"
          />
        </a>

        <div className="zHHBD-bet-hero__content">
          <header className="zHHBD-bet-hero__header">
            <h1 className="zHHBD-bet-hero__title">
              HHBD বেট – বাংলাদেশি খেলোয়াড়দের জন্য লাইভ স্পোর্টস বেটিং
            </h1>
            <p className="zHHBD-bet-hero__desc">
              HHBD Bets-এ স্বাগতম — অনলাইন স্পোর্টস{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
              অনুরাগীদের জন্য দেশের নির্ভরযোগ্য গন্তব্য। আপনার বিশ্লেষণকে বাস্তব ফলাফলে রূপ দিন{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
              করে প্রিয় ক্লাব, তারকা অ্যাথলিট এবং বড় টুর্নামেন্টে। আবিষ্কার করুন গভীর মার্কেট, ভ্যালু-ফার্স্ট প্রাইসিং এবং শক্তিশালী{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
              টুল যা গতি ও মোমেন্টামের জন্য তৈরি। HHBD-এ আবেগের সাথে সুযোগের মিলন—এখনই ডুব দিন!
            </p>
          </header>

          <div className="zHHBD-bet-hero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bet-hero__btn zHHBD-bet-hero__btn--main"
              title="আপনার HHBD স্পোর্টসবুক অ্যাকাউন্ট খুলে এখনই বেটিং শুরু করুন"
            >
              আজই HHBD-এ যোগ দিন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-bet-hero__btn zHHBD-bet-hero__btn--ghost"
              title="অফিশিয়াল HHBD অ্যান্ড্রয়েড স্পোর্টসবুক অ্যাপ ডাউনলোড করুন"
              download
            >
              APK ডাউনলোড করুন
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-sportsbet">
      <div className="zHHBD-sportsbet__bg">
        <div className="zHHBD-sportsbet__flare zHHBD-sportsbet__flare--left"></div>
        <div className="zHHBD-sportsbet__flare zHHBD-sportsbet__flare--right"></div>
      </div>

      <div className="container hr-cont">
        <header className="zHHBD-sportsbet__header">
          <h2 className="zHHBD-sportsbet__title">
            খুব কাছ থেকে HHBD স্পোর্টসবুক অভিজ্ঞতা
          </h2>
        </header>
        <p className="zHHBD-sportsbet__desc">
          HHBD আপনাকে প্রতিটি মুহূর্তের কেন্দ্রে নিয়ে যায়—ফুল-স্কেল, প্রবাহমান{" "}
          <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
          ইকোসিস্টেমসহ। আমাদের লক্ষ্য—বাংলাদেশের স্পোর্টস কমিউনিটির জন্য সিল্কি, মুগ্ধকর{" "}
          <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
          যাত্রা। আপনি পুরোনো যোদ্ধা হোন বা একদম নতুন, আপনার প্রয়োজনীয় টুল ও মার্কেট এখানে হাতের নাগালেই।
        </p>
        <p className="zHHBD-sportsbet__desc">
          আমরা বিশ্বজুড়ে বিশাল ফিক্সচার তালিকা কভার করি—সাথে স্থানীয় সমর্থকদের সবচেয়ে প্রিয় লড়াইগুলোর ওপর বিশেষ ফোকাস। বাংলাদেশ প্রিমিয়ার লিগের রোমাঞ্চ থেকে FIFA World Cup-এর নাটকীয়তা—প্রতিটি বড় গল্পে আপনি{" "}
          <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেট</Link>{" "}
          করতে পারবেন। আঞ্চলিক ও বৈশ্বিক—দুই জগতেরই গেটওয়ে এখানেই শুরু।
        </p>
        <p className="zHHBD-sportsbet__desc">
          HHBD-এ{" "}
          <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেট</Link>{" "}
          রাখা দ্রুত ও ইন্টুইটিভ। ম্যাচ বেছে নিন, লাইভ লাইন মূল্যায়ন করুন, আর কয়েক সেকেন্ডেই স্টেক কনফার্ম করুন। সুশৃঙ্খল নেভিগেশনে আপনি ফেভারিটকে সমর্থন বা তাৎক্ষণিক ভ্যালু শিকার—যা চান তাই করতে স্বাধীন।
        </p>
        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-sportsbet__btn"
          title="HHBD-এ থাকা সব স্পোর্টস ও লাইভ মার্কেট দেখুন"
        >
          এখনই HHBD-এ যোগ দিন
        </a>
      </div>
    </section>

    <section className="zHHBD-sports-cards">
      <div className="zHHBD-sports-cards__bg">
        <div className="zHHBD-sports-cards__burst zHHBD-sports-cards__burst--1"></div>
        <div className="zHHBD-sports-cards__burst zHHBD-sports-cards__burst--2"></div>
      </div>

      <div className="zHHBD-sports-cards__container">
        <header className="zHHBD-sports-cards__header">
          <h2 className="zHHBD-sports-cards__title">কেন আপনার স্পোর্টসবুক হবে HHBD?</h2>
          <div className="zHHBD-sports-cards__desc">
            <p></p>
          </div>
        </header>

        <div className="zHHBD-sports-cards__grid">
          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">বেট রাখার সঠিক ঘর বেছে নেওয়াই পুরো যাত্রাকে সংজ্ঞায়িত করে।</div>
              <div className="zHHBD-sports-cards__card-text">
                HHBD দেয় মজবুত, নির্ভরযোগ্য পরিবেশ—যা উত্তেজনা বাড়ায়, আবার প্রতিটি সেশনকে সুরক্ষিতও রাখে। বাংলাদেশজুড়ে বেটরদের জন্য আমরা প্রতিশ্রুতিবদ্ধ এক রিওয়ার্ডিং, ট্রান্সপারেন্ট ও ভ্যালু-ড্রিভেন প্ল্যাটফর্মে।
              </div>
            </div>
          </div>

          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">আমাদের লাইনগুলো ধারালো—নিয়মিত প্রতিযোগিতামূলক অডস দিয়ে আলাদা।</div>
              <div className="zHHBD-sports-cards__card-text">
                আপনার{" "}
                <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেট</Link>{" "}
                থেকে শক্তিশালী এক্সপেক্টেড রিটার্ন পেতে আমরা বইকে নিয়ত টিউন করি। তীক্ষ্ণ প্রাইসিং মানে বড় সম্ভাব্য পেআউট—টিম বা তারকা পারফর্মারকে ব্যাক করলে বাড়তি আপসাইড।
              </div>
            </div>
          </div>

          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">প্রতিটি ম্যাচআপে বিশাল মার্কেট ডেপথ উপভোগ করুন।</div>
              <div className="zHHBD-sports-cards__card-text">
                শুধু উইনার বাছাই নয়—আপনি{" "}
                <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেট</Link>{" "}
                করতে পারেন টোটালস, প্লেয়ার মাইলস্টোন, হ্যান্ডিক্যাপ এবং লাইভ অ্যাকশনের ওঠানামায় নানান ইন-প্লে আউটকামে—মোমেন্টাম বদলালে মার্কেটও বদলায়।
              </div>
            </div>
          </div>

          <div className="zHHBD-sports-cards__card">
            <div className="zHHBD-sports-cards__card-content">
              <div className="zHHBD-sports-cards__card-tag">প্রায় সব খেলাকেই জুড়ে রাখা এক সত্যিকারের বিস্তৃত স্পোর্টসবুক।</div>
              <div className="zHHBD-sports-cards__card-text">
                ওয়ার্ল্ড-স্টেজের মহাযজ্ঞ থেকে শুরু করে স্থানীয় বাংলাদেশি সংঘর্ষ—আমাদের কাভারেজ গভীর। আপনি যা-ই অনুসরণ করুন না কেন, পাবেন রোমাঞ্চকর{" "}
                <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
                অ্যাঙ্গেল ও আপনার কৌশলের উপযোগী মার্কেট।
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-livebet">
      <div className="zHHBD-livebet__bg">
        <div className="zHHBD-livebet__flare zHHBD-livebet__flare--1"></div>
        <div className="zHHBD-livebet__flare zHHBD-livebet__flare--2"></div>
      </div>

      <div className="zHHBD-livebet__container">
        <div className="zHHBD-livebet__content">
          <header className="zHHBD-livebet__header">
            <h2 className="zHHBD-livebet__title">
              লাইভ ইন-প্লে ওয়েজারের অ্যাড্রেনালিন অনুভব করুন
            </h2>
          </header>

          <div className="zHHBD-livebet__descbox">
            <p className="zHHBD-livebet__desc">
              ম্যাচডে সুপারচার্জ করুন HHBD-এর রিয়েল-টাইম ইন-প্লে{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "} দিয়ে। খেলা এগোতে থাকুক—আপনি মুহূর্তেই বদলে যাওয়া এজ ধরে{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটস</Link>{" "}
              রাখুন। লাইভ, ক্রমাগত আপডেট হওয়া দামে সঠিক সময়ে ভ্যালু খুঁজে পেতে পারবেন—ঠিক তখনই স্টেক দিন।
            </p>
            <p className="zHHBD-livebet__desc">
              লাইভ{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
              সবচেয়ে মানানসই তাদের জন্য যারা প্রতিটি ডেলিভারি ও পাস অনুসরণ করেন। গোল, বাউন্ডারি, উইকেট, কার্ড বা টার্নিং মোমেন্ট—প্রতিক্রিয়া দিন, তারপর অনুমেয় পরের ঘটনায় লক্ষ্যভেদী{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেট</Link>{" "}
              রাখুন। এতে আপনার HHBD{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটিং</Link>{" "}
              অভিজ্ঞতায় যুক্ত হয় টাইমিং, কৌশল ও অতিরিক্ত থিয়েটার।
            </p>
            <p className="zHHBD-livebet__desc">
              লাইভ{" "}
              <Link className="rr555-aviatorlux__link" to={getLangPath("/bet", lang)}>বেটস</Link>{" "}
              আরও ধারালো করতে ব্যবহার করুন রিয়েল-টাইম পরিসংখ্যান ও ভিজ্যুয়াল ম্যাচ ট্র্যাকার। এতে স্পষ্ট হয় টেম্পো, টার্নিং পয়েন্ট ও গুরুত্বপূর্ণ প্রবণতা—আগাম আঁচ করতে সহজ হয়। HHBD থাকলে স্মার্টার ইন-প্লে ওয়েজার সবসময় এক ট্যাপ দূরে।
            </p>
          </div>

          <div className="zHHBD-livebet__cta">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-livebet__btn"
              title="HHBD-এ আপনার জন্য প্রস্তুত সব লাইভ ও আগত মার্কেট দেখুন"
            >
              HHBD-এ বেট করুন
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Bet — বাংলাদেশজুড়ে রিয়েল-টাইম ওয়েজারিং ও বড় জয়"
        >
          <img
            src={b6}
            alt="HHBD-এ জেতা ক্রিকেট বেটের আনন্দে উচ্ছ্বসিত বাংলাদেশি সমর্থক—ফোনে স্কোর দেখছেন।"
            title="HHBD Bet — বাংলাদেশজুড়ে রিয়েল-টাইম ওয়েজারিং ও বড় জয়"
          />
        </a>
      </div>
    </section>
  </>

      )}
    </>
  );
};

export default Bet;
